import token from './{token}';
import del from './delete';

export default { del, token };
